module.exports = __webpack_public_path__ + "media/bootstrap-icons/square-fill-a674db8c.svg";